import "./filter.css";
import { useEffect, useState } from "react";
import { useLanguage } from "../../../../../hooks";
import {
  FilterProps,
  FiltersProps,
  objectToKeyValueArray,
  OperationFilterButtonProps,
} from "./filter.props";
import { Icon } from "../../../../icon";
import { Lines3Fill, TrashOutline, XMarkFill } from "../../../../../assets";
import { Modal } from "../../../../modal";

const OperationFilterButton: React.FC<OperationFilterButtonProps> = ({
  show,
  disabled = false,
  modal,
  className,
}) => {
  const { t } = useLanguage();
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [okDisabled, setOkDisabled] = useState<boolean>(false);

  const handleOk = () => {
    modal.onOk();
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      {show && (
        <>
          <button
            className={`operation-filter-button ${
              disabled ? "disabled" : ""
            } ${className}`}
            onClick={() => setIsModalOpen(true)}
            disabled={disabled}
          >
            <Icon
              icon={Lines3Fill}
              alt="Icon filter"
              className="operation-filter-button-icon"
            />
            <p>{t.components.operations.area.filters.filter}</p>
          </button>
          <Modal
            title={t.components.operations.area.filters.filter}
            open={isModalOpen}
            setOpen={handleCancel}
            actions={[
              {
                text: modal.textButton.length
                  ? modal.textButton
                  : t.components.operations.area.filters.toFilter,
                onClick: handleOk,
                disabled: okDisabled,
              },
            ]}
            backdropClosable={modal.backdropClosable ?? true}
          >
            {modal.content}
          </Modal>
        </>
      )}
    </>
  );
};

export default OperationFilterButton;

export const ActiveFilters: React.FC<FiltersProps> = ({
  filters,
  pathFilterL,
  formatValue,
  deleteByKey,
  deleteAll,
}) => {
  const { t } = useLanguage();

  const [arrFilters, setArrFilters] = useState<FilterProps[]>([]);

  useEffect(() => {
    const newArray = objectToKeyValueArray(filters);
    setArrFilters(newArray);
  }, [filters]);

  return (
    <>
      {arrFilters.length > 0 && (
        <div className="operation-filter-active-wrapper">
          <p>{t.components.operations.area.filters.activeFilters}</p>
          {arrFilters.map((item, index) => {
            return (
              <button
                key={`filter-item-${index}`}
                onClick={(e) => {
                  e.preventDefault();
                  deleteByKey(item.key);
                }}
                className="operation-filter-active-button"
              >
                <p>{pathFilterL?.[String(item.key).trim()] ?? ""}:</p>
                <p className="operation-filter-active-button-bold">
                  {formatValue ? formatValue(item.key, item.value) : item.value}
                </p>
                <Icon
                  icon={XMarkFill}
                  alt="Delete Filter"
                  className="operation-filter-active-button-icon"
                />
              </button>
            );
          })}

          {arrFilters.length > 1 && (
            <button
              className="operation-filter-active-button-delete-all"
              onClick={(e) => {
                e.preventDefault();
                deleteAll();
              }}
            >
              <Icon
                icon={TrashOutline}
                alt="Delete all filters"
                className="operation-filter-active-button-delete-all-icon"
              />
            </button>
          )}
        </div>
      )}
    </>
  );
};
